import Validation from '@core/logic/Validation'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import ClientDeclaration from '@company-common/model/kyc-form/ClientDeclaration'
import TrustedIndividual from '@master/model/kyc-form/TrustedIndividual'

export default class ClientDeclarationValidation extends Validation {
  validate (clientDecl: ClientDeclaration, trustedIndividual: TrustedIndividual, client2Included: boolean, kycForm: KYCForm, belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, REQUIRE_TRUE, WHEN } = this.validator()

    ADD(REQUIRE(clientDecl.reviewDate, 'Date of First Appointment is required'), ['Client Summary'], ['reviewDate'])

    ADD(REQUIRE(clientDecl.clientDeclFcProvideCopy, 'CA Declaration Acknowledgement must be filled'), ['Client\'s Declaration'], ['clientDeclFcProvideCopy'])
    ADD(REQUIRE_TRUE(clientDecl.clientDeclFcProvideCopy, 'CA Declaration Acknowledgement must be true'), ['Client\'s Declaration'], ['clientDeclFcProvideCopy'])

    ADD(REQUIRE(clientDecl.clientDeclStatements, 'CA Declaration Statement must be filled'), ['Client\'s Declaration'], ['clientDeclStatements'])
    ADD(REQUIRE_TRUE(clientDecl.clientDeclStatements, 'CA Declaration Statement must be true'), ['Client\'s Declaration'], ['clientDeclStatements'])

    ADD(REQUIRE(clientDecl.clientDeclAdvisoryProcess, 'Declaration Advisory Process must be filled'), ['Client\'s Declaration'], ['clientDeclAdvisoryProcess'])

    ADD(REQUIRE(clientDecl.clientDeclIntroduced, 'Declaration of Introduced Option must be filled'), ['Client\'s Declaration'], ['clientDeclIntroduced'])
    ADD(WHEN(clientDecl.clientDeclIntroduced === 'yes', REQUIRE(clientDecl.clientDeclIntroducedName, 'Introducer Name must be filled with declaration of introducer is yes')), ['Client\'s Declaration'], ['clientDeclIntroducedName'])
    ADD(WHEN(clientDecl.clientDeclIntroduced === 'yes', REQUIRE(clientDecl.clientDeclIntroducedId, 'Introducer Id must be filled with declaration of introducer is yes')), ['Client\'s Declaration'], ['clientDeclIntroducedId'])

    // ADD(REQUIRE(clientDecl.clientDeclPoliticallyExposed, 'Declaration of Political Exposed Person must be filled'), ['Client\'s Declaration'])

    // PEP should out from Common
    // ADD(REQUIRE(clientDecl.client0DeclarationPoliticallyExposed, 'Declaration of Political Exposed Person for Client 1 must be filled'), ['Client\'s Declaration'])
    // ADD(WHEN(client2Included === true, REQUIRE(clientDecl.client1DeclarationPoliticallyExposed, 'Declaration of Political Exposed Person for Client 2 must be filled')), ['Client\'s Declaration'])

    ADD(WHEN(kycForm.recommendations.rcmd.length > 0, REQUIRE_TRUE(clientDecl.clientDeclAcknowledgement, 'Client Acknowledgement Declaration must be filled')), ['Client\'s Decision'], ['clientDeclAcknowledgement'])

    ADD(REQUIRE(clientDecl.disclosure, 'Disclosure Option must be filled'), ['Disclaimers & Client\'s Checklist'], ['disclosure'])
    ADD(REQUIRE_TRUE(clientDecl.disclosure, 'Disclosure Option must be true'), ['Disclaimers & Client\'s Checklist'], ['disclosure'])

    ADD(REQUIRE(clientDecl.disclosureAps, 'Disclosure APS Option must be filled'), ['Disclaimer & Client\'s Checklist'], ['disclosureAps'])
    ADD(REQUIRE_TRUE(clientDecl.disclosureAps, 'Disclosure APS Option must be true'), ['Disclaimers & Client\'s Checklist'], ['disclosureAps'])

    // To be double confirm
    ADD(REQUIRE(clientDecl.contactingYou, 'Contacting You option must be filled'), ['Disclaimers & Client\'s Checklist'], ['contactingYou'])
    ADD(REQUIRE_TRUE(clientDecl.contactingYou, 'Contacting You option must be true'), ['Disclaimers & Client\'s Checklist'], ['contactingYou'])
    ADD(REQUIRE(clientDecl.crcPartI, 'Client\'s Reference Checklist I must be filled'), ['Disclaimers & Client\'s Checklist'], ['crcPartI'])
    ADD(REQUIRE_TRUE(clientDecl.crcPartI, 'Client\'s Reference Checklist I must be true'), ['Disclaimers & Client\'s Checklist'], ['crcPartI'])
    ADD(REQUIRE(clientDecl.crcPartIi, 'Client\'s Reference Checklist II must be filled'), ['Disclaimers & Client\'s Checklist'], ['crcPartIi'])
    ADD(REQUIRE_TRUE(clientDecl.crcPartIi, 'Client\'s Reference Checklist II must be true'), ['Disclaimers & Client\'s Checklist'], ['crcPartIi'])
    ADD(REQUIRE(clientDecl.crcPartIii, 'Client\'s Reference Checklist III must be filled'), ['Disclaimers & Client\'s Checklist'], ['crcPartIii'])
    ADD(REQUIRE_TRUE(clientDecl.crcPartIii, 'Client\'s Reference Checklist III must be true'), ['Disclaimers & Client\'s Checklist'], ['crcPartIii'])
    ADD(REQUIRE(clientDecl.crcPartIv, 'Client\'s Reference Checklist IV must be filled'), ['Disclaimers & Client\'s Checklist'], ['crcPartIv'])
    ADD(REQUIRE_TRUE(clientDecl.crcPartIv, 'Client\'s Reference Checklist IV must be true'), ['Disclaimers & Client\'s Checklist'], ['crcPartIv'])

    ADD(REQUIRE(clientDecl.explainedFeesCharges, 'Explained Fee Charges Option must be filled'), ['Client\'s Declaration'], ['explainedFeesCharges'])

    ADD(REQUIRE(clientDecl.pdpaConsent, 'PDPA Consent Option must be filled'), ['Client\'s Declaration'], ['pdpaConsent'])

    // Trusted Individual/ Client’s Accompaniment
    ADD(WHEN(trustedIndividual.accompanied === 'yes' && trustedIndividual.confirmLanguage === 'others', REQUIRE(trustedIndividual.confirmLanguageOthers, 'Others Languages has to be filled when Others is chosen.')), ['Client\'s Declaration'], ['confirmLanguageOthers'])

    ADD(WHEN(clientDecl.client0DeclarationPoliticallyExposed === 'yes', () => {
      if (!clientDecl.pepList || clientDecl.pepList.length === 0 || !clientDecl.pepList.find(pep => pep.policyholderName === 'C1')) {
        return 'There should be at least 1 political personal details for client 1'
      }

      let errorMsg = null
      clientDecl.pepList.forEach((pep) => {
        if (pep.isNotComplete() && pep.policyholderName === 'C1') {
          errorMsg = 'Poltically Exposed Person Details (for client 1) is not filled properly.'
        }
      })
      return errorMsg
    }), ['Politically Exposed Person Form'])

    ADD(WHEN(client2Included === true && clientDecl.client1DeclarationPoliticallyExposed === 'yes', () => {
      if (!clientDecl.pepList || clientDecl.pepList.length === 0 || !clientDecl.pepList.find(pep => pep.policyholderName === 'C2')) {
        return 'There should be at least 1 political personal details for client 2'
      }

      let errorMsg = null
      clientDecl.pepList.forEach((pep) => {
        if (pep.isNotComplete() && pep.policyholderName === 'C2') {
          errorMsg = 'Poltically Exposed Person Details (for client 2) is not filled properly.'
        }
      })
      return errorMsg
    }), ['Politically Exposed Person Form'])

    return getMessages()
  }

  // to made PEP validation out from common
  validatePEP (clientPEP: string, belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE } = this.validator()
    ADD(REQUIRE(clientPEP, 'Declaration of Political Exposed Person must be filled'), ['Client\'s Declaration'])
    return getMessages()
  }
}
